import * as Sentry from "@sentry/vue";

export default defineNuxtPlugin((nuxtApp) => {
  const { releaseLevel, SentryDSN } = useRuntimeConfig().public;
  const { vueApp } = nuxtApp;
  const router = useRouter();

  Sentry.init({
    app: vueApp,
    dsn: SentryDSN,
    integrations: [
      Sentry.browserTracingIntegration({ router }),
      Sentry.replayIntegration(),
    ],

    // Only capture errors from our own domains
    allowUrls: [
      /https?:\/\/localhost(:\d+)?/,
      /https?:\/\/(staging\.)?(www\.)?(allefolders\.nl|promopromo\.be|myshopi\.com)/,
      /https?:\/\/.*\.jafolders\.com/,
    ],

    // Exclude browser extensions and third-party scripts
    denyUrls: [
      /extensions\//i,
      /^chrome:\/\//i,
      /^chrome-extension:\/\//i,
      /^moz-extension:\/\//i,
      /^safari-extension:\/\//i,
      /webkit-masked-url/,
    ],

    // Ignore known non-actionable errors
    ignoreErrors: [
      // Browser/network noise
      "Non-Error promise rejection captured",
      "AbortError",
      // Chunk loading (usually network issues)
      /Loading chunk .* failed/,
      /ChunkLoadError/,
      "Importing a module script failed",
      // Third-party/extension related
      /SecurityError.*localStorage/,
      /SecurityError.*sessionStorage/,
      "can't access dead object",
      // User-initiated
      "User denied",
      "Permission denied",
    ],

    // Set tracesSampleRate to 1.0 to capture 100%
    // of transactions for performance monitoring.
    // We recommend adjusting this value in production
    tracesSampleRate: 0.01,

    // Capture Replay for 10% of all sessions,
    // plus for 100% of sessions with an error
    replaysSessionSampleRate: 0.01,
    replaysOnErrorSampleRate: 1.0,

    environment: releaseLevel,
  });
});
